import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '@/pages/login';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  reason: z.enum(['inactivity', 'password-changed']).optional(),
});

export const Route = createFileRoute('/_public/login/')({
  validateSearch: loginSearchSchema,
  component: LoginPage,
});
